import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  SafeAreaView,
  StyleSheet,
  View,
  ActivityIndicator,
} from 'react-native';
import { get as _get, isEmpty } from 'lodash';
import moment from 'moment';
import { Icon } from 'react-native-elements';
import { CalendarList } from 'react-native-calendars';

import SearchBar from '../../components/SearchBar';
import { getCommunityCalendarAPI } from '../../api/adserver';
import { BuildingSelectionProps } from '../../navigation';
import { is } from 'immer/dist/internal';

type Props = {} & BuildingSelectionProps;

const CommunityCalendarScreen: React.FC<Props> = ({
  navigation,
  route,
}: any) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const { contentId } = useMemo(() => {
    return {
      contentId: _get(route, 'params.contentId', ''),
    };
  }, [route]);
  console.log(`CalendarScreen, contentId: ${contentId}`);

  const onDayPress = useCallback(
    ({ dateString }: { dateString: string }) => {
      console.log('onDayPress', dateString);
      if (dateString) {
        navigation.push('CommunityAgenda', {
          selected: dateString,
          events: _get(data, 'community_calendar_events', []),
        });
      }
    },
    [data, navigation],
  );

  const loadData = useCallback(async () => {
    const d = await getCommunityCalendarAPI();
    setData(d);
    setLoading(false);
  }, [setData]);

  const getMarkedDates = useCallback(() => {
    let dates: any = {};
    const events = _get(data, 'community_calendar_events', []);
    events.forEach((item: any) => {
      dates[moment(item.start_date_time).format('YYYY-MM-DD')] = {
        marked: true,
      };
    });

    return dates;
  }, [data]);

  useEffect(() => {
    console.log('loading data for calendar');
    loadData();
  }, [loadData]);

  useEffect(() => {
    const events = _get(data, 'community_calendar_events', []);
    if (contentId && !isEmpty(events)) {
      onDayPress({ dateString: contentId });
    }
  }, [contentId, data, onDayPress, navigation]);

  const renderCalendar = () => {
    if (loading) {
      return (
        <View style={styles.loader}>
          <ActivityIndicator animating color="red" />
        </View>
      );
    }

    return (
      <CalendarList onDayPress={onDayPress} markedDates={getMarkedDates()} />
    );
  };

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.searchWrapper}>
        <Icon
          name="arrow-back"
          size={30}
          color="#ffffff"
          onPress={navigation.goBack}
          tvParallaxProperties={null}
        />
        <View style={styles.searchBar}>
          <SearchBar placeholder="Search" />
        </View>
      </View>
      <View style={[styles.scrollView]}>{renderCalendar()}</View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#333333',
    flex: 1,
  },
  scrollView: {
    backgroundColor: '#f7f7f7',
    flex: 1,
  },
  searchWrapper: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#333333',
    paddingStart: 10,
  },
  searchBar: {
    flex: 1,
  },
  loader: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default CommunityCalendarScreen;
